/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Tooltip } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import BuildIcon from '@mui/icons-material/Build';
import GavelIcon from '@mui/icons-material/Gavel';
import LocalGasStationIcon from '@mui/icons-material/LocalGasStation';
import SettingsIcon from '@mui/icons-material/Settings';
import SpeedIcon from '@mui/icons-material/Speed';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { StatCardV2 } from '../../../components/v2';
import {
  CATEGORIAS,
  CATEGORIA_STAT_COLORS,
  EMPTY_KPIS,
  formatBRL,
  formatKm,
} from './constants';

const TOTAL_KEY = '__TOTAL__';

const KPI_CARDS = [
  {
    key: TOTAL_KEY,
    kpiKey: 'totalGasto',
    label: 'Total Gasto',
    icon: <AttachMoneyIcon />,
    color: 'primary',
    filterable: false,
    format: formatBRL,
    valueFontSize: '1.5rem',
  },
  {
    key: CATEGORIAS.COMBUSTIVEL,
    kpiKey: 'combustivel',
    label: CATEGORIAS.COMBUSTIVEL,
    icon: <LocalGasStationIcon />,
    color: CATEGORIA_STAT_COLORS[CATEGORIAS.COMBUSTIVEL],
    filterable: true,
    format: formatBRL,
  },
  {
    key: CATEGORIAS.MANUTENCAO,
    kpiKey: 'manutencao',
    label: CATEGORIAS.MANUTENCAO,
    icon: <BuildIcon />,
    color: CATEGORIA_STAT_COLORS[CATEGORIAS.MANUTENCAO],
    filterable: true,
    format: formatBRL,
  },
  {
    key: CATEGORIAS.PECAS,
    kpiKey: 'pecas',
    label: CATEGORIAS.PECAS,
    icon: <SettingsIcon />,
    color: CATEGORIA_STAT_COLORS[CATEGORIAS.PECAS],
    filterable: true,
    format: formatBRL,
  },
  {
    key: CATEGORIAS.MULTAS,
    kpiKey: 'multas',
    label: CATEGORIAS.MULTAS,
    icon: <GavelIcon />,
    color: CATEGORIA_STAT_COLORS[CATEGORIAS.MULTAS],
    filterable: true,
    format: formatBRL,
  },
  {
    key: 'kmRodado',
    kpiKey: 'kmRodado',
    label: 'KM Rodado',
    icon: <SpeedIcon />,
    color: 'info',
    filterable: false,
    format: formatKm,
    nullHint: 'Sem registros de odômetro no período',
  },
  {
    key: 'custoPorKm',
    kpiKey: 'custoPorKm',
    label: 'Custo/KM',
    icon: <TrendingUpIcon />,
    color: 'success',
    filterable: false,
    format: formatBRL,
    nullHint: 'Indisponível sem KM rodado',
  },
];

const KpiStrip = ({ kpis, loading, activeCategoria, onSelectCategoria }) => {
  const data = kpis || EMPTY_KPIS;

  const handleClick = (card) => {
    if (!card.filterable || !onSelectCategoria) return;
    onSelectCategoria(activeCategoria === card.key ? null : card.key);
  };

  return (
    <Grid container spacing={2}>
      {KPI_CARDS.map((card) => {
        const rawValue = data[card.kpiKey];
        const isNullMetric = rawValue == null && card.nullHint;
        const displayValue = isNullMetric ? '—' : card.format(rawValue ?? 0);
        const isActive = card.filterable && activeCategoria === card.key;

        const cardNode = (
          <StatCardV2
            label={card.label}
            value={displayValue}
            icon={card.icon}
            color={card.color}
            loading={loading}
            active={isActive}
            activeLabel={isActive ? 'Filtro ativo — clique para remover' : undefined}
            valueFontSize={card.valueFontSize}
            onClick={card.filterable ? () => handleClick(card) : undefined}
          />
        );

        return (
          <Grid key={card.key} size={{ xs: 6, sm: 4, md: 3 }}>
            {isNullMetric ? (
              <Tooltip title={card.nullHint} arrow placement="top">
                <span>{cardNode}</span>
              </Tooltip>
            ) : (
              cardNode
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

KpiStrip.propTypes = {
  kpis: PropTypes.object,
  loading: PropTypes.bool,
  activeCategoria: PropTypes.string,
  onSelectCategoria: PropTypes.func,
};

KpiStrip.defaultProps = {
  kpis: EMPTY_KPIS,
  loading: false,
  activeCategoria: null,
  onSelectCategoria: null,
};

export default KpiStrip;
